import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../nav_bar/Navbar";
import { fetchPaymentHistory } from "../../services/paymentHistoryService";
import { PLAN_TYPE_META } from "../../../common/constants";

const ICON = {
  GROUP:            "👥",
  ONE_ON_ONE:       "👤",
  PARTNER_PRACTICE: "🤝",
  COMBO:            "📦",
};

const STATUS_CONFIG = {
  SUCCESS: { label: "Payment Successful", icon: "✅", color: "#2e7d32", bg: "#e6f4ea" },
  FAILED:  { label: "Payment Failed",     icon: "❌", color: "#c62828", bg: "#fdecea" },
  CREATED: { label: "Initiated",          icon: "🕐", color: "#555",    bg: "#f0f0f0" },
  PENDING: { label: "Pending",            icon: "⏳", color: "#b45309", bg: "#fef9c3" },
};

const TransactionHistoryPage = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading]           = useState(true);
  const [error, setError]               = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchPaymentHistory()
      .then((res) => setTransactions(res.data || []))
      .catch((err) => {
        if (err.response?.status === 401) navigate("/login");
        else setError("Failed to load transaction history.");
      })
      .finally(() => setLoading(false));
  }, [navigate]);

  return (
    <div>
      <Navbar />
      <div style={s.container}>
        <div style={s.header}>
          <button style={s.backBtn} onClick={() => navigate("/my-active-plan")}>← Back</button>
          <h2 style={s.heading}>Transaction History</h2>
        </div>

        {loading && <p style={s.center}>Loading...</p>}
        {error   && <p style={{ ...s.center, color: "#c62828" }}>{error}</p>}

        {!loading && !error && transactions.length === 0 && (
          <p style={s.center}>No transactions found.</p>
        )}

        {!loading && !error && transactions.length > 0 && (
          <div style={s.list}>
            {transactions.map((tx) => {
              const status = STATUS_CONFIG[tx.status] || STATUS_CONFIG.PENDING;
              const planIcon = tx.planType ? (ICON[tx.planType] || "📋") : "📋";
              const planLabel = tx.planType ? (PLAN_TYPE_META[tx.planType]?.displayName ?? tx.planType) : null;

              return (
                <div key={tx.id} style={s.row}>
                  {/* Left: date + plan info */}
                  <div style={s.rowLeft}>
                    <div style={s.date}>
                      {tx.date
                        ? new Date(tx.date).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })
                        : "—"}
                      <span style={s.time}>
                        {tx.date
                          ? new Date(tx.date).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })
                          : ""}
                      </span>
                    </div>
                    <div style={s.planName}>
                      {planIcon} {tx.planName || "Plan (deleted)"}
                    </div>
                    {planLabel && (
                      <div style={s.planType}>{planLabel}</div>
                    )}
                    {tx.status === "SUCCESS" && tx.razorpayPaymentId && (
                      <div style={s.refId}>Ref: {tx.razorpayPaymentId}</div>
                    )}
                  </div>

                  {/* Right: amount + status */}
                  <div style={s.rowRight}>
                    <div style={s.amount}>
                      {tx.amount != null ? `₹${tx.amount.toLocaleString("en-IN")}` : "—"}
                    </div>
                    <div style={{ ...s.statusBadge, color: status.color, background: status.bg }}>
                      {status.icon} {status.label}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

const s = {
  container: { padding: "32px 20px", maxWidth: "800px", margin: "0 auto" },
  header:    { display: "flex", alignItems: "center", gap: 16, marginBottom: 24 },
  backBtn:   { background: "none", border: "1px solid #ddd", borderRadius: 8, padding: "6px 14px",
               cursor: "pointer", fontSize: "0.9rem", color: "#555" },
  heading:   { fontSize: "1.6rem", fontWeight: 700, color: "#333", margin: 0 },
  center:    { textAlign: "center", marginTop: 60, color: "#888" },

  list:      { display: "flex", flexDirection: "column", gap: 12 },
  row:       { display: "flex", justifyContent: "space-between", alignItems: "flex-start",
               background: "#fff", borderRadius: 12, border: "1px solid #eee",
               boxShadow: "0 2px 8px rgba(0,0,0,0.05)", padding: "16px 20px", gap: 12 },
  rowLeft:   { display: "flex", flexDirection: "column", gap: 4, flex: 1 },
  rowRight:  { display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 6, flexShrink: 0 },

  date:      { fontSize: "0.75rem", color: "#aaa", display: "flex", alignItems: "center", gap: 6 },
  time:      { fontSize: "0.72rem", color: "#ccc" },
  planName:  { fontSize: "1rem", fontWeight: 600, color: "#333" },
  planType:  { fontSize: "0.75rem", color: "#888" },
  refId:     { fontSize: "0.7rem", color: "#aaa", fontFamily: "monospace" },

  amount:      { fontSize: "1.2rem", fontWeight: 700, color: "#333" },
  statusBadge: { fontSize: "0.72rem", fontWeight: 600, padding: "3px 10px",
                 borderRadius: 20, whiteSpace: "nowrap" },
};

export default TransactionHistoryPage;
